// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-bitacora-action__container[data-v-76f4ad36] {\n  background-color: #fafafa;\n}\n.file-input__container[data-v-76f4ad36] {\n  min-width: 200px;\n  margin-right: 10px;\n}", ""]);
// Exports
module.exports = exports;
